import useFadeUp from '../hooks/useFadeUp';

const testimonials = [
  {
    initials: 'ד.כ',
    name: 'דנה כהן',
    trip: 'צפון איטליה ושוויץ, 2025',
    dest: '🇮🇹🇨🇭',
    text: 'דרום טירול, אגם בראיס, לוגאנו - נוף שלא ייאמן. כל לילה במלון שונה, כשר ומפנק. מגד שמיים בנו לנו מסלול שהרגיש כמו חלום.',
  },
  {
    initials: 'י.ל',
    name: 'יוסי לוי',
    trip: 'רומא, 2025',
    dest: '🇮🇹',
    text: 'רומא עם כשרות? מגד שמיים ידעו בדיוק איפה. הקולוסאום, הרובע היהודי העתיק, בית הכנסת הספרדי ורחובות הטראסטוורה - עם מסעדה כשרה מעולה בכל עצירה.',
  },
  {
    initials: 'מ.ר',
    name: 'מיכל רוזנברג',
    trip: 'פראג, 2024',
    dest: '🇨🇿',
    text: 'ביקרנו בבית הכנסת של המהר"ל ברובע היהודי - חוויה מרגשת שלא אשכח. מגד שמיים שילבו היסטוריה יהודית עמוקה עם חוויות תיירותיות מדהימות.',
  },
  {
    initials: 'א.ש',
    name: 'אבי שמעוני',
    trip: 'לונדון, 2024',
    dest: '🇬🇧',
    text: 'לונדון עם הילדים - Tower Bridge, הפארקים המלכותיים, ושוק מהחרה בגולדרס גרין. מגד שמיים ידעו איפה הקהילה היהודית ואיפה הכשרות הכי טובה.',
  },
  {
    initials: 'ר.ב',
    name: 'רותי ברנשטיין',
    trip: 'מדריד וברצלונה, 2025',
    dest: '🇪🇸',
    text: 'קאסה בטיו של גאודי, הפראדו, ופלמנקו חי - ספרד ברמה אחרת. כל מסעדה הייתה כשרה ומדהימה, והמדריך היה זמין 24/7.',
  },
  {
    initials: 'ג.פ',
    name: 'גל פרידמן',
    trip: 'אמסטרדם, 2024',
    dest: '🇳🇱',
    text: 'תעלות אמסטרדם, גיטהורן, וזאנסה סכנס - הולנד מהחלום. ביקרנו בבית הכנסת הפורטוגזי ההיסטורי ואכלנו כשר ברמה גבוהה לאורך כל הדרך.',
  },
];

function TestCard({ t, delay }) {
  const ref = useFadeUp(delay);
  return (
    <div ref={ref} className="bg-white border border-brand-blue/10 rounded-2xl p-7
                               hover:shadow-card transition-shadow duration-200">
      <div className="text-brand-blue tracking-[3px] text-sm mb-4">★★★★★</div>
      <p className="font-display font-normal text-[15px] leading-[1.8] text-gray-700 mb-6">
        {t.text}
      </p>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-brand-beige border-2 border-brand-blue-light
                        flex items-center justify-center font-body font-semibold
                        text-sm text-brand-blue flex-shrink-0">
          {t.initials}
        </div>
        <div>
          <div className="font-body font-semibold text-sm text-gray-900">{t.name}</div>
          <div className="font-body font-light text-xs text-gray-400">{t.trip}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const headerRef = useFadeUp(0);
  return (
    <section id="testimonials" className="py-24 px-6 bg-brand-beige-light">
      <div ref={headerRef} className="text-center mb-12">
        <span className="inline-block bg-brand-blue-light text-brand-blue
                         text-[11px] font-bold tracking-[2px] uppercase
                         px-4 py-1.5 rounded-full mb-3">
          המלצות
        </span>
        <h2 className="font-display font-bold text-[clamp(1.8rem,3vw,2.6rem)]
                       leading-tight tracking-tight text-gray-900 mb-3">
          מה אומרים עלינו?
        </h2>
        <p className="font-body font-light text-gray-500 text-[1.05rem]">
          משפחות שחזרו מאירופה עם חיוך - הנה מה שהן אומרות
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {testimonials.map((t, i) => (
          <TestCard key={t.name} t={t} delay={i % 3 * 100} />
        ))}
      </div>
    </section>
  );
}